import { render, staticRenderFns } from "./cTomBuyTypeList .vue?vue&type=template&id=a0b2bcdc&"
import script from "./cTomBuyTypeList .vue?vue&type=script&lang=js&"
export * from "./cTomBuyTypeList .vue?vue&type=script&lang=js&"
import style0 from "./cTomBuyTypeList .vue?vue&type=style&index=0&id=a0b2bcdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports